import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchChatSearchApi, ChatSearchParams } from '../../api/chat';

export const fetchChatSearchAsync = createAsyncThunk(
  'chat/fetchChatSearch',
  async (params: ChatSearchParams) => {
    const data = await fetchChatSearchApi(params);
    return data;
  }
);

type ChatState = {
  chatData: any;
  loading: boolean;
  error: string | null;
  message: string | null;
  currentParams: ChatSearchParams;
  showDropdown: boolean;
};

const initialState: ChatState = {
  chatData: null,
  loading: false,
  error: null,
  message: null,
  currentParams: { query: '' },
  showDropdown: false,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
    clearMessage(state) {
      state.message = null;
    },
    clearChatData(state) {
      state.chatData = null;
    },
    setChatParams(state, action) {
      state.currentParams = action.payload;
    },
    setShowDropdown(state, action) {
      state.showDropdown = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchChatSearchAsync.pending, state => {
        state.loading = true;
        state.error = null;
        state.showDropdown = true;
      })
      .addCase(fetchChatSearchAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.chatData = action.payload;
        state.showDropdown = true;
      })
      .addCase(fetchChatSearchAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch chat search';
        state.showDropdown = false;
      });
  },
});

export const { clearError, clearMessage, clearChatData, setChatParams, setShowDropdown } = chatSlice.actions;
export default chatSlice.reducer;
